module.exports = __webpack_public_path__ + "img/lieve-tandarts-vierkant.83dfa15c.png";